import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleRisquesDonneesIA() {
  return (
    <BlogArticleLayout
      tag="IA & Cybersécurité"
      title="Risques liés aux données utilisées par les IA de l'entreprise"
      date="24 novembre 2026"
      ctaTitle="Vérifiez vos flux de données vers vos systèmes d'IA"
      ctaText="Le diagnostic identifie les points de vigilance sur les données que vos systèmes d'IA traitent ou reçoivent."
    >
      <p style={s.intro}>
        Un système d'IA n'est jamais neutre vis-à-vis des données qu'il manipule : données d'entrée, données
        de personnalisation, parfois données utilisées pour l'entraîner. Chacune de ces étapes pose ses
        propres questions de confidentialité et de sécurité.
      </p>

      <h2 style={s.h2}>Les données que vous envoyez à un système d'IA</h2>
      <p>
        Que ce soit via une intégration technique ou un usage direct, les données transmises à un système
        d'IA externe échappent partiellement à votre contrôle une fois envoyées. La question à se poser
        systématiquement : ce fournisseur utilise-t-il ces données pour entraîner ses propres modèles, ou
        les traite-t-il uniquement pour répondre à votre requête ?
      </p>

      <h2 style={s.h2}>Les données de personnalisation et de contexte</h2>
      <p>
        De nombreux systèmes d'IA s'appuient sur des données contextuelles (historique client, documents
        internes) pour améliorer leurs réponses. Ces données doivent être soumises aux mêmes exigences de
        sécurité et de minimisation que n'importe quelle autre donnée sensible de l'entreprise — voir notre
        article
        {' '}<Link to="/blog/securite-des-donnees-rgpd" style={s.link}>sur la sécurité des données selon le RGPD</Link>.
      </p>

      <h2 style={s.h2}>Le risque de ré-identification et de fuite indirecte</h2>
      <p>
        Même des données apparemment anonymisées peuvent parfois être recoupées ou ré-identifiées lorsqu'elles
        transitent par un système d'IA qui les combine avec d'autres sources. Ce risque est souvent
        sous-estimé car moins visible qu'une fuite directe.
      </p>

      <h2 style={s.h2}>La qualité des données comme risque de sécurité</h2>
      <p>
        Des données d'entrée erronées, biaisées ou corrompues peuvent conduire un système d'IA à produire des
        résultats incorrects utilisés ensuite pour des décisions opérationnelles — un risque de fiabilité qui
        rejoint les enjeux de sécurité, sans s'y limiter.
      </p>

      <h2 style={s.h2}>Ce qu'il faut vérifier concrètement</h2>
      <p>
        Pour chaque système d'IA utilisé, identifiez quelles données lui sont transmises, où elles sont
        hébergées, et sous quelles conditions contractuelles — voir notre article
        {' '}<Link to="/blog/gestion-fournisseurs-ia" style={s.link}>sur la gestion des fournisseurs IA</Link>{' '}
        pour les points de contrôle à formaliser avec chaque prestataire.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleRisquesDonneesIA;
